var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.25 1.2375C22.6281 1.2375 0.25 23.6344 0.25 51.2375C0.25 73.3406 14.575 92.075 34.4281 98.6844C36.9375 99.1563 37.8438 97.6094 37.8438 96.2719C37.8438 95.0844 37.8156 91.9438 37.7969 87.775C23.8813 90.7875 20.95 81.0531 20.95 81.0531C18.6719 75.2906 15.3844 73.7438 15.3844 73.7438C10.8594 70.6531 15.7438 70.7188 15.7438 70.7188C20.7563 71.0594 23.3938 75.8594 23.3938 75.8594C27.8531 83.5094 35.0938 81.2969 37.9594 80.0094C38.3969 76.7875 39.7 74.5719 41.1188 73.3375C30.0187 72.0844 18.3469 67.7875 18.3469 48.6281C18.3469 43.1562 20.2844 38.7 23.4875 35.2C22.9344 33.9469 21.2406 28.8531 23.9281 21.9656C23.9281 21.9656 28.1125 20.6313 37.6781 27.0938C41.6813 25.9844 45.9313 25.4313 50.1781 25.4031C54.4281 25.4313 58.675 25.9875 62.6781 27.0938C72.1875 20.6313 76.3688 21.9656 76.3688 21.9656C79.0531 28.8531 77.3594 33.9438 76.8719 35.2C80.0437 38.7 81.9812 43.1594 81.9812 48.6281C81.9812 67.8313 70.2937 72.0656 59.1812 73.2875C60.9188 74.7844 62.5469 77.8625 62.5469 82.5344C62.5469 89.2219 62.4844 94.6094 62.4844 96.2375C62.4844 97.5375 63.3594 99.1 65.9344 98.5969C85.9344 92.0563 100.244 73.3063 100.244 51.2344C100.244 23.6313 77.8656 1.23438 50.2438 1.23438L50.25 1.2375Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7036ee727cd5da1469428c2ba6758062.svg";
export { ForwardRef as ReactComponent };